import { useEffect } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { useState } from "react";
import { Button, Container, Typography, Box, Tab, Tabs, styled, Modal, TextField } from "@mui/material";
import moment from 'moment'
import 'moment/locale/it';
import { savePdf as saveElenco } from "../courses/pdfs/elenco_partecipanti";
import { savePdf as saveLettera } from "../courses/pdfs/scheda_ammissione_corso";
import { savePdf as saveProgrammazione } from "../courses/pdfs/programmazione_corso";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { AuthHelper } from "../../controllers/AuthHelper";
import DataTable from "../../components/Table";
import { CreateTicket } from "../../../CreateTicket";

import { getPDF as ProgrammazionePDF } from "../courses/pdfs/programmazione_corso_base64";
import { getPDF as LetteraPDF } from "../courses/pdfs/lettera_esami_base64";
import { getPdf as ElencoPDF } from "../courses/pdfs/elenco_partecipanti_base64";
import { ServerConfig } from "../../../connectors/Config";
import { momentLocalizer } from 'react-big-calendar'
import { Drawer } from "@mui/material";
import { useRef } from "react";

moment.locale('it');
momentLocalizer(moment)
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const columns = [
    //{ field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header'},
    { field: 'first_name', headerName: 'Nome', width: 200, headerClassName: 'data-grid-header' },
    { field: 'last_name', headerName: 'Cognome', width: 200, headerClassName: 'data-grid-header' },
    { field: 'phone_number', headerName: 'Numero di Telefono', width: 200, headerClassName: 'data-grid-header' },
    { field: 'fiscal_code', headerName: 'Codice Fiscale', width: 200, headerClassName: 'data-grid-header' },
    { field: 'birth_province', headerName: 'Provincia di Nascita', width: 200, headerClassName: 'data-grid-header' },
    { field: 'birthplace', headerName: 'Città di Nascita', width: 200, headerClassName: 'data-grid-header' },
    { field: 'city_residence', headerName: 'Città di Residenza', width: 200, headerClassName: 'data-grid-header' },
    //{ field: 'birthday', headerName: 'Data di Nascita', width: 200, headerClassName: 'data-grid-header' },
   { 
    field: 'birthday', 
    headerName: 'Data di Nascita', 
    width: 200,
    valueFormatter: (params) => {
      return params.value ? moment(params.value).format('DD-MM-YYYY') : '';
    }
  },

];

const AntTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
      minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(1),
    color: '#888',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&.Mui-selected': {
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#d1eaff',
    },
  }));
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const ModalCapitaneria = (props) => {
    const handleOpen = () => props.setOpen(true);
    const handleClose = () => props.setOpen(false);
  
    return (
        <Modal
          open={props.open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Sei sicuro di voler inviare la comunicazione alla capitaneria?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Verrà inviata la comunicazione precompilata con i seguenti allegati:
              <ul>
                <li>
                  <div onClick={async (e) => {
                    e.preventDefault();
                    try{
                      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/print/${props.course}`);
                      const payload = await res.json();
                      await saveLettera(payload);
                    }catch(ex){
                      alert("Setup corso non completo");
                    }
                   
                  }}>
                    Lettera conferma sessione esami
                  </div>
                </li>
                <li>
                <div onClick={async (e) => {
                    e.preventDefault();
                    try{
                      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${props.course}`);
                      const payload = await res.json();
                      await saveElenco(payload);
                    }catch(ex){
                      alert("Setup corso non completo");
                    }
                   
                  }}>
                    Elenco partecipanti
                  </div>
                </li>
                <li>
                <div onClick={async (e) => {
                    e.preventDefault();
                    try{
                      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${props.course}`);
                      const payload = await res.json();
                      const partecipants = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/partecipants/${props.course}`)).json();
                      const lessons = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/lessons/${props.course}`)).json();
                      await saveProgrammazione({...payload, lessons: lessons, partecipants});
                    }catch(ex){
                      alert("Setup corso non completo");
                    }
                   
                  }}>
                    Programmazione corso
                  </div>
                </li>
              </ul>
            </Typography>
            <TextField fullWidth minRows={4} multiline placeholder="Messaggio aggiuntivo a capitaneria" />
            <div style={{display: 'flex'}}>
              <Button color="error" onClick={handleClose}>Annulla</Button>
              <Button onClick={async () => {
                 const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/print/${props.course}`);
                 const payload = await res.json();
                 const partecipants = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/partecipants/${props.course}`)).json();
                 const lessons = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/lessons/${props.course}`)).json();
                 const base64Progr = await ProgrammazionePDF({...payload, lessons: lessons, partecipants});
                 const base64Lettr = await LetteraPDF({...payload, lessons, partecipants});
                 const base64Elenco = await ElencoPDF({...payload, lessons, partecipants});
                 
                 let user = await AuthHelper.getUserFromIdToken();
                 await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/email`, {
                   method: 'POST',
                   body: JSON.stringify({
                     base64Progr,
                     base64Lettr,
                     base64Elenco,
                     school: user.Username,
                     course: payload.generalCourse['nome corso'],
                     courseId: payload.course.dataValues.id,
                     dates: `${moment(payload.course.dataValues.from).format('DD/MM/YYYY')} - ${moment(payload.course.dataValues.to).format('DD/MM/YYYY')}`
                   })
                 })
                console.error("Performing btoa on an invalid base64 string in nodemailer!")
              }}>Invia</Button>
            </div>
          </Box>
        </Modal>
    );
  }
const ListCustomers = () => {

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedDiscente, setSelectedDiscente] = useState(null);

    const [dashboard, setDashboard] = useState({
      starting: [],
      subscription: [],
      ended: [],
      pec: []
    })
    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    const [ticketOpen, setTicketOpen] = useState(false);
    const [statistics, setStatistics] = useState({
      trainingCenter: 0,
      reviewScore: 0,
      reviewScoreTeachers: 0,
    });

    const getStatistics = async() => {
      let user = await AuthHelper.getUserFromIdToken();
      try{
        const res = await fetch( `${ServerConfig.AWS.Serverless.API_BASE_URL_1}/school/${user.Username}`);
        const json = await res.json();
        const settings = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/centri/settings/${user.Username}`)).json();
        let points = 0;
        if(settings.logo_top)points += 10;
        if(settings.image_bottom)points += 5;
        if(settings.capitaneria)points += 15;
        if(json.school.logo && json.school.name && json.school.url && json.school.description && json.school.sede_legale && json.school.indirizzo_scuola && json.school.piva && json.school.email)points += 30;
        if(json.gallery.length > 0)points += 40;
        const reviews = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/user/prenotations/review/${user.Username}`)).json();
        
        setStatistics({
          trainingCenter: points,
          reviewScoreTeachers: reviews.reduce((acc, review) => acc + review.didattica, 0) / reviews.length,
          reviewScore: reviews.reduce((acc, review) => acc + Number(review.score), 0)/ reviews.length
        })
      }catch(ex){
          console.log(ex);
      }
    }

   const saveDiscente = async () => {
  if (!selectedDiscente?.id) {
    alert("ID discente mancante!");
    return;
  }

  try {
    const res = await fetch(
      `${ServerConfig.AWS.Serverless.API_BASE_URL_2}/modify/discente`, // rimuovo l'id dall'URL
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(selectedDiscente), // contiene già id
      }
    );

    if (!res.ok) {
      const error = await res.json();
      throw new Error(error.message || "Errore durante il salvataggio");
    }

    setDrawerOpen(false);
    await getMarittimi(); // refresh tabella
  } catch (err) {
    console.error(err);
    alert("Errore durante il salvataggio: " + err.message);
  }
};



    useEffect(() => {
      console.log(statistics);
    }, [statistics])

    const [jsonIscritti, setJsonIscritti] = useState([]);
    const getDashboard = async() => {
      let user = await AuthHelper.getUserFromIdToken();

      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/schools/dashboard/${user.Username}`);
      const json = await res.json();

      // Difensivo: l'API puo' restituire un oggetto di errore invece degli array attesi.
      // NB: l'endpoint /schools/dashboard restituisce ogni sezione come array a 2 elementi
      // [ arrayRighe, oggettoMetadataPostgres ]. Il componente piu' avanti accede sempre
      // a [0] (le righe). NON va ordinato il wrapper esterno: il vecchio
      // `[...coursesStarting].sort(...)` confrontava un array e un oggetto metadata
      // (entrambi senza campo 'from' -> moment(undefined) = ora corrente) e riordinava
      // in modo NON deterministico il wrapper, finendo a volte per mettere l'oggetto
      // metadata in posizione [0]. Al render `starting[0].sort(...)` falliva con
      // "o.sort is not a function" -> "Unexpected Application Error".
      const coursesStarting = Array.isArray(json?.coursesStarting) ? json.coursesStarting : [];
      setDashboard({
        starting: coursesStarting,
        pec: Array.isArray(json?.pecSent) ? json.pecSent : [],
        subscription: Array.isArray(json?.partecipants) ? json.partecipants : [],
        ended: Array.isArray(json?.previousCourses) ? json.previousCourses : []
      })
      const firstGroup = Array.isArray(coursesStarting[0]) ? coursesStarting[0] : [];
      const requestInfo = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/course/info/list`, {
        method: 'POST',
        body: JSON.stringify({
          courses: firstGroup.map(course => (`'${course.id}'`))
        })
      });
      const requestJson = await requestInfo.json();
      setJsonIscritti(Array.isArray(requestJson?.payload?.[0]) ? requestJson.payload[0] : []);
    }
    const groupedCourses = (array) => array.reduce((acc, course) => {
      const courseName = course["nome corso"];
      if (!acc[courseName]) {
        acc[courseName] = [];
      }
      acc[courseName].push(course);
      return acc;
    }, {});
    const groupedSubscription = (array) => array.reduce((acc, course) => {
      const courseName = course["nome corso"];
      if (!acc[courseName]) {
        acc[courseName] = [];
      }
      acc[courseName].push(course);
      return acc;
    }, {});

    const [marittimi, setMarittimi] = useState([]);
    const [open, setOpen] = useState(false);
    const [course, setCourse] = useState("");

    const getMarittimi = async() => {
      let user = await AuthHelper.getUserFromIdToken();

      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/schools/partecipants/${user.Username}`)
      const marittimiJson = await res.json();
      setMarittimi(Array.isArray(marittimiJson?.[0]) ? marittimiJson[0] : []);
    }
    useEffect(() => {
      getDashboard();
      getStatistics();
      getMarittimi();
    }, [])
    // Difensivo: le sezioni della dashboard arrivano come [ righe, metadataPg ];
    // estraggo SEMPRE un array di righe valido per evitare crash al render.
    const startingRows = Array.isArray(dashboard.starting?.[0]) ? dashboard.starting[0] : [];
    const endedRows = Array.isArray(dashboard.ended?.[0]) ? dashboard.ended[0] : [];
    return (<Container sx={{paddingLeft: 24, paddingRight: 24, minWidth: '85vw', marginTop: '3rem', textAlign: 'left'}}>

      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)} sx={{'& .MuiDrawer-paper': { width: 400, boxSizing: 'border-box',},}}>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
   
          {/* HEADER GRADIENT */}
          <Box sx={{background: "linear-gradient(to bottom right, #9DCEE2, #7256CB)", color: "#fff",height: "80px",display: "flex",alignItems: "center", px: 2,}}>
            <Typography variant="h6">Modifica Discente</Typography>
          </Box>

    {/* BODY */}
    <Box sx={{ flex: 1, overflowY: "auto", bgcolor: "#fafafa", p: 2 }}>
      <TextField
        fullWidth
        label="Nome"
        margin="normal"
        value={selectedDiscente?.first_name || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            first_name: e.target.value
          })
        }
      />
      <TextField
        fullWidth
        label="Cognome"
        margin="normal"
        value={selectedDiscente?.last_name || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            last_name: e.target.value
          })
        }
      />
  

      <TextField
        fullWidth
        label="Codice Fiscale"
        margin="normal"
        value={selectedDiscente?.fiscal_code || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            fiscal_code: e.target.value
          })
        }
      />

      <TextField
        fullWidth
        label="Numero di Telefono"
        margin="normal"
        value={selectedDiscente?.phone_number || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            phone_number: e.target.value
          })
        }
      />
      <TextField
        fullWidth
        label="Provincia di Nascita"
        margin="normal"
        value={selectedDiscente?.birth_province || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            birth_province: e.target.value
          })
        }
      />
      <TextField
        fullWidth
        label="Città di Nascita"
        margin="normal"
        value={selectedDiscente?.birthplace || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            birthplace: e.target.value
          })
        }
      />
      <TextField
        fullWidth
        label="Città di Residenza"
        margin="normal"
        value={selectedDiscente?.city_residence || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            city_residence: e.target.value
          })
        }
      />
      <TextField
        fullWidth
        label="Data di Nascita"
        type="date"
        margin="normal"
        InputLabelProps={{ shrink: true }}
        value={selectedDiscente?.birthday || ''}
        onChange={(e) =>
          setSelectedDiscente({
            ...selectedDiscente,
            birthday: e.target.value
          })
        }
      />

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2 }}
        onClick={saveDiscente}
      >
        Salva
      </Button>
    </Box>
  </Box>
</Drawer>






        <ModalCapitaneria open={open} setOpen={setOpen} course={course}></ModalCapitaneria>
           <Button sx={{backgroundColor: 'rgb(191, 163, 73)',               fontWeight: 'bold', paddingX: 4, paddingY: 1, borderRadius: 66, fontSize: 12, marginBottom: 3}}                  onClick={() => window.location.href="/dashboard/accreditamento"}>Lista accreditamento corsi</Button> 
           <Button sx={{backgroundColor: 'rgb(39, 245, 73)',             marginLeft: 2, fontWeight: 'bold', paddingX: 4, paddingY: 1, borderRadius: 66, fontSize: 12, marginBottom: 3,color: '#fff' }} onClick={() => window.location.href = "/dashboard/prezziario"}>Prezziario</Button>
           <Button sx={{backgroundColor: 'rgb(4,14,99)',             marginLeft: 2, fontWeight: 'bold', paddingX: 4, paddingY: 1, borderRadius: 66, fontSize: 12, marginBottom: 3,color: '#fff' }} onClick={() => window.location.href = "/dashboard/pacchetti"}>Pacchetti corsi</Button>
           <Button sx={{backgroundColor: 'rgb(191, 73, 73)', marginLeft: 2, fontWeight: 'bold', paddingX: 4, paddingY: 1, borderRadius: 66, fontSize: 12, marginBottom: 3, color: '#fff'}} onClick={() => setTicketOpen(true)}>Invia ticket</Button>

        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <AntTab label="Operations" {...a11yProps(0)} />
          <AntTab label="Data" {...a11yProps(1)} />
          <AntTab label='Archivio "Corsi Conclusi"' {...a11yProps(2)} />
          <AntTab label='Database discenti' {...a11yProps(3)} />
        </Tabs>
      <CreateTicket modalOpen={ticketOpen} setModalOpen={setTicketOpen} />
      <CustomTabPanel value={value} index={0}>
        <div style={{display: 'flex', gap: 12, justifyContent: 'space-between'}}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'space-between', textAlign: 'left'}}>
                <h3>Corsi in partenza</h3>
                {startingRows.length > 0 && [...startingRows].sort((a,b) => moment(a.from).diff(moment(b.from))).map(course => (
                  <div style={{display: 'flex', gap: 12, alignItems: 'center'}}  onClick={() => window.location.href=`/dashboard/corso/${course['id']}?nome_corso=${encodeURIComponent(course['nome corso'])}&id=${course['course_id']}&start=${course['from']}&end=${course['to']}`}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>{course['numero_partecipanti']}</div>
                    <h4>{course['nome corso']} ({moment(course['from']).format('DD/MM/YYYY')} - {moment(course['to']).format('DD/MM/YYYY')})</h4>
                  </div>
                ))}
            </div>
            <div style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
                <h3>Richieste Iscritti</h3>
                {startingRows.length > 0 && [...startingRows].sort((a,b) => moment(a.from).diff(moment(b.from))).map(course => (
                  <div style={{display: 'flex', gap: 12, alignItems: 'center'}}  onClick={() => window.location.href=`/dashboard/corso/${course['id']}?nome_corso=${encodeURIComponent(course['nome corso'])}&id=${course['course_id']}&start=${course['from']}&end=${course['to']}#richieste_iscritti`}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>{jsonIscritti.filter(x => x.course === course['id']).length}</div>
                    <h4>{course['nome corso']} ({moment(course['from']).format('DD/MM/YYYY')} - {moment(course['to']).format('DD/MM/YYYY')})</h4>
                  </div>
                ))}
            </div>
            <div style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
                <h3>Comunicazioni Capitaneria</h3>
                  {startingRows.length > 0 && startingRows.filter(x => moment(x['from']).diff(moment(), 'days') <= 7).sort((a,b) => moment(a.from).diff(moment(b.from))).map(course => (
                    <div style={{display: 'flex', gap: 12, alignItems: 'center'}}  onClick={() => {setOpen(true); setCourse(course['id'])}}>
                      <div style={{padding: '6px 12px', background: dashboard.pec?.some(x => x.course_id === course['id']) ? '#73e067' : '#D22B2B', color: '#fff', borderRadius: 6}}>3</div>
                      {dashboard.pec?.some(x => x.course_id === course['id']) ?
                        <>
                          <div style={{padding: '6px 12px', background: '#73e067', color: '#fff', borderRadius: 6}}>OK</div>
                          <h4>{course['nome corso']} ({moment(course['from']).format('DD/MM/YYYY')} - {moment(course['to']).format('DD/MM/YYYY')})</h4>
                        </>
                      :
                      (<>
                        {moment(course['from']).diff(moment(), 'hours') > 24 ? <div style={{padding: '6px 12px', background: moment(course['from']).diff(moment(), 'hours') > 72 ? '#FFFF00' : '#D22B2B', color: moment(course['from']).diff(moment(), 'hours') > 72 ? '#000' : '#fff', borderRadius: 6}}>P</div> : <div style={{padding: '6px 12px', background: '#D22B2B', color: '#fff', borderRadius: 6}}><strong>D</strong></div>}
                        <h4>{course['nome corso']} ({moment(course['from']).format('DD/MM/YYYY')} - {moment(course['to']).format('DD/MM/YYYY')})</h4>
                      </>)
                      }
                      
                    </div>
                  ))}
            </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <div style={{display: 'flex', gap: 12, justifyContent: 'space-between'}}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'space-between', textAlign: 'left'}}>
                <h3>Il tuo Score</h3>
                <div style={{display: 'flex', gap: 12, alignItems: 'center'}}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>{statistics.trainingCenter}%</div>
                    <h4>Traning Center Page Score</h4>
                </div>
                <div style={{display: 'flex', gap: 12, alignItems: 'center'}}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>{statistics.reviewScore.toFixed(1)}/5</div>
                    <h4>Review Score Marittimi</h4>
                </div>
                <div style={{display: 'flex', gap: 12, alignItems: 'center'}}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>{statistics.reviewScoreTeachers.toFixed(1)}/5</div>
                    <h4>Review Score Docenti</h4>
                </div>
                {/* <div style={{display: 'flex', gap: 12, alignItems: 'center'}}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>0%</div>
                    <h4>Review Search Score 30 Days</h4>
                </div> */}
            </div>
            <div style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
                <h3>% Presenze Marittimi</h3>
                {startingRows.length > 0 && startingRows.map(course => (
                  <div style={{display: 'flex', gap: 12, alignItems: 'center'}}  onClick={() => window.location.href=`/dashboard/corso/${course['id']}?nome_corso=${encodeURIComponent(course['nome corso'])}&id=${course['course_id']}&start=${course['from']}&end=${course['to']}`}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>{Math.round(course['numero_partecipanti'] / 20 * 100)}%</div>
                    <h4>{course['nome corso']}</h4>
                  </div>
                ))}
                
            </div>
            <div style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
                <h3>Richieste Capitaneria</h3>
                <div style={{display: 'flex', gap: 12, alignItems: 'center'}}>
                    Nessuna richiesta capitaneria.
                </div>
                
            </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <div style={{display: 'flex', gap: 12, justifyContent: 'space-between'}}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'space-between', textAlign: 'left'}}>
                <h3>Corsi Conclusi</h3>
                {endedRows.length > 0 && endedRows.map(course => (
                  <div style={{display: 'flex', gap: 12, alignItems: 'center'}}  onClick={() => window.location.href=`/dashboard/corso/${course['id']}?nome_corso=${encodeURIComponent(course['nome corso'])}&id=${course['course_id']}&start=${course['from']}&end=${course['to']}`}>
                    <div style={{padding: '6px 12px', background: 'rgb(191, 163, 73)', color: '#fff', borderRadius: 6}}>{course['numero_partecipanti']}</div>
                    <h4>{course['nome corso']} ({moment(course['from']).format('DD/MM/YYYY')} - {moment(course['to']).format('DD/MM/YYYY')})</h4>
                  </div>
                ))}
            </div>
            <div style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
                <h3>Documenti Corso</h3>
                {endedRows.length > 0 && endedRows.map(course => (
                  <div style={{display: 'flex', gap: 12, alignItems: 'center'}}  onClick={() => window.location.href=`/dashboard/corso/${course['id']}?nome_corso=${encodeURIComponent(course['nome corso'])}&id=${course['course_id']}&start=${course['from']}&end=${course['to']}`}>
                     <div style={{padding: '6px 12px', background: dashboard.pec?.some(x => x.course_id === course['id']) ? '#73e067' : '#D22B2B', color: '#fff', borderRadius: 6}}>3</div>
                     {dashboard.pec?.some(x => x.course_id === course['id']) ?
                        <>
                          <div style={{padding: '6px 12px', background: '#73e067', color: '#fff', borderRadius: 6}}>OK</div>
                          <h4>{course['nome corso']} ({moment(course['from']).format('DD/MM/YYYY')} - {moment(course['to']).format('DD/MM/YYYY')})</h4>
                        </>
                      :
                      (<>
                        <div style={{padding: '6px 12px', background: '#D22B2B', color: '#fff', borderRadius: 6}}>P</div>
                        <h4>{course['nome corso']} ({moment(course['from']).format('DD/MM/YYYY')} - {moment(course['to']).format('DD/MM/YYYY')})</h4>
                      </>)
                      }
                  </div>
                ))}
                
            </div>
            <div style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
                <h3>Documenti per capitaneria</h3>
                <div style={{display: 'flex', gap: 12, alignItems: 'center'}}>
                    Nessun documento per capitaneria.
                </div>
                
            </div>
        </div>
      </CustomTabPanel>



     <CustomTabPanel value={value} index={3}>
        <div style={{display: 'flex', gap: 12, justifyContent: 'space-between'}}>
                <DataTable 
                    data={marittimi.filter(x => x.id)} 
                    columns={columns}
                    handleClick={(params) => {
                      setSelectedDiscente(params.row);
                      setDrawerOpen(true);
                    }}
                />
        </div>
      </CustomTabPanel>
          





    </Container>);

}

export default ListCustomers;